import React from 'react'
import Highcharts from 'highcharts/highcharts'
import HighchartsReact from 'highcharts-react-official'
import CloseCircle from '../icons/CloseCircle'
import ContainerHeading from '../layout/ContainerHeading'
import HelmetTitle from '../../components/layout/HelmetTitle'
import Moment from 'moment-timezone'
import GraphActionsBar from './GraphActionsBar'
import styledTheme from '../../styles/theme'
import axios from 'axios'

import { DataViewModalContainer, ContainerHeadingActionIcon, GaugeContentWrapper, GaugeContainer, GaugeHeading } from './styled-elements'

export default class Gauge extends React.Component {

  constructor(props) {
    super(props)
    const layoutWidth=this.getLayoutWdth()
    const layoutHeight=this.getLayoutHeight()
    const isSmallScreen=(layoutWidth < styledTheme.breakpoints.lg)
    const mobileLandscapeView=(isSmallScreen && (layoutWidth > layoutHeight))
    this.state = {
      layoutWidth,
      layoutHeight,
      isSmallScreen,
      mobileLandscapeView,
    }
    this.graphContainerDiv = React.createRef()
    this.highChartsChart = React.createRef()
  }

  getLayoutWdth = () => {
    if (typeof window === 'undefined') return styledTheme.breakpoints.lg
    return window.innerWidth
  }

  getLayoutHeight = () => {
    if (typeof window === 'undefined') return (styledTheme.breakpoints.lg*9/16)
    return window.innerHeight
  }

  formatSeries = (seriesArray) => seriesArray.map(series => {
    if (series.yAxis==='y_axis_percent' && series.offset_enabled) {
      return {
        ...series,
        tooltip: {
          pointFormatter: function() {
            return '<span style="color:' + this.color + '">\u25CF</span> ' + series.name + ' <b>' + (this.y+series.offset).toFixed(2) + '%</b><br/>'
          }
        }
      }
    }
    return series
  })

  processOptions = (options,props,state) => {
    const mobileDisplayOptions = {}
    // if (state.layoutWidth < styledTheme.breakpoints.lg) {
    //   mobileDisplayOptions['scrollbar'] = { enabled: false }
    //   //mobileDisplayOptions['legend'] = { enabled: false }
    //   //mobileDisplayOptions['rangeSelector'] = { enabled: false }
    //   const xAxis = { ...options['xAxis'] }
    //   const maxUnixTimeMoment = Moment(new Date(xAxis[0]['max']))
    //   const monthAgoUnixtime = maxUnixTimeMoment.clone().subtract(1,'M')
    //   const xAxisRange = maxUnixTimeMoment.diff(monthAgoUnixtime)
    //   xAxis['range'] = xAxisRange
    //   xAxis['startOnTick'] = true
    //   xAxis['endOnTick'] = true
    //   xAxis['ordinal'] = false
    //   mobileDisplayOptions['xAxis'] = xAxis
    // }
    // options.chart['height'] = this.state.chartContainerHeight-20 || "100%";
    // options.chart['width'] = this.state.chartContainerWidth-20 || 300;
    return {
      ...options,
      ...mobileDisplayOptions,
      series: this.formatSeries(options.series.slice()),
    }
  }

  componentDidMount = () => {
  }

  componentWillUnmount = () => {
  }

  componentDidUpdate = () => {
  }

  updateChartContainerDimensions() {
    if (
      (this.graphContainerDiv) &&
      (this.graphContainerDiv.current) &&
      (
        (this.state.chartContainerHeight!==this.graphContainerDiv.current.offsetHeight) ||
        (this.state.chartContainerWidth!==this.graphContainerDiv.current.offsetWidth)
      )
    ) {
        this.setState({
          chartContainerHeight: this.graphContainerDiv.current.offsetHeight,
          chartContainerWidth: this.graphContainerDiv.current.offsetWidth,
        })
    }
  }

  removeHighchartsCredit = () => {
    const highchartsCreditElArray = document.querySelectorAll('.highcharts-credits')
    if (highchartsCreditElArray.length) {
      const highchartsCredit = highchartsCreditElArray[0]
      highchartsCredit.parentNode.removeChild(highchartsCredit)
    }
  }

  renderBody = (props,state) => {

    const { site, dataView, options, includeGraphActions } = props

    console.log('XXX options',options)


    const gaugeOptions = {

      chart: {
        type: 'solidgauge',
        height: 300,
      },

      title: null,

      pane: {
        center: [ "50%", "55%" ],
        size: '110%',
        startAngle: -130,
        endAngle: 130,
        background: [{ // Track for Move
          outerRadius: '100%',
          innerRadius: '92%',
          backgroundColor: 'rgba(0,0,0,0.15)',
          borderWidth: 0,
          shape: 'arc',
        },{
          outerRadius: '90%',
          innerRadius: '82%',
          backgroundColor: 'rgba(0,0,0,0.15)',
          borderWidth: 0,
          shape: 'arc',
        },{
          outerRadius: '80%',
          innerRadius: '72%',
          backgroundColor: 'rgba(0,0,0,0.15)',
          borderWidth: 0,
          shape: 'arc',
        },{
          outerRadius: '70%',
          innerRadius: '62%',
          backgroundColor: 'rgba(0,0,0,0.15)',
          borderWidth: 0,
          shape: 'arc',
        },{
          outerRadius: '60%',
          innerRadius: '52%',
          backgroundColor: 'rgba(0,0,0,0.15)',
          borderWidth: 0,
          shape: 'arc',
        }]
      },

      exporting: {
        enabled: true
      },

      tooltip: {
          borderWidth: 0,
          backgroundColor: 'none',
          shadow: false,
          style: {
            fontFamily: '\'Helvetica Neue\', Helvetica, Arial, sans-serif;',
            fontSize: '14px'
          },
          valueSuffix: '%',
          valueDecimals: 2,
          pointFormat: '{series.name}<br><span style="font-size:2em; color: \'#333333\'; font-weight: bold">{point.y}</span>',
          positioner: function (labelWidth) {
            return {
                x: (this.chart.chartWidth - labelWidth) / 2,
                y: (this.chart.plotHeight/2.5)
            };
          }
      },
      // the value axis
      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 2,
        minorTicks: false,
        tickWidth: 2,
        tickAmount: 2,
        labels: {
          distance: '75%',
          align: 'auto',
          style: {
              fontSize: "20px"
          }
        },
      },

      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: false
          },
          linecap: 'round',
          stickyTracking: false,
          rounded: true,
        }
      }

    }

    const chartIndividualDepths = Highcharts.merge(gaugeOptions, {

      yAxis: {
        lineWidth: 0,
        tickWidth: 2,
        tickLength: 74,
        tickColor: '#999',
        tickPosition: 'inside',
        minorTickWidth: 0,
        minorTickLength: 0,
        tickPositions: [38,55],
        zIndex: 100,
      },

      credits: {
        enabled: false
      },

      series: [{
        name: '10cm',
        data: [{
          radius: '100%',
          innerRadius: '92%',
          y: 21.97,
          color: "#EB2128",
        }],
        tooltip: {
          valueSuffix: '%'
        }
      },{
        name: '20cm',
        data: [{
          radius: '90%',
          innerRadius: '82%',
          y: 23.60,
          color: "#EB2128",
        }],
      },{
        name: '30cm',
        data: [{
          radius: '80%',
          innerRadius: '72%',
          y: 45.80,
          color: "#45F074",
        }],
      },{
        name: '40cm',
        data: [{
          radius: '70%',
          innerRadius: '62%',
          y: 57.65,
          color: "#45B0F0",
        }],
      },{
        name: '50cm',
        data: [{
          radius: '60%',
          innerRadius: '52%',
          y: 36.90,
          color: "#EB2128",
        }],
      }]
    })

    const rootZoneGaugeOptions = {

      chart: {
        type: 'solidgauge',
        height: 300,
      },

      title: null,

      pane: {
        center: [ "50%", "55%" ],
        size: '110%',
        startAngle: -130,
        endAngle: 130,
        background: [{ // Track for Move
          outerRadius: '100%',
          innerRadius: '52%',
          backgroundColor: 'rgba(0,0,0,0.15)',
          shape: 'arc',
        }]
      },

      exporting: {
        enabled: false
      },

      tooltip: {
        enabled: false
      },

      // the value axis
      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 2,
        minorTicks: false,
        tickWidth: 2,
        tickAmount: 2,
        labels: {
          distance: '75%',
          align: 'auto',
          style: {
              fontSize: "20px"
          }
        },
      },

      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: true
          },
        }
      }

    }

    const chartRootZone = Highcharts.merge(rootZoneGaugeOptions, {

      yAxis: {
        lineWidth: 0,
        tickWidth: 2,
        tickLength: 74,
        tickColor: '#999',
        tickPosition: 'inside',
        minorTickWidth: 0,
        minorTickLength: 0,
        tickPositions: [38,55],
        zIndex: 100,
      },

      credits: {
        enabled: false
      },

      series: [{
        name: 'Root zone',
        data: [{
          radius: '100%',
          innerRadius: '52%',
          y: 39.22,
          color: "#45F074",
        }],
        dataLabels: {
          borderWidth: 0,
          style: {
            fontFamily: '\'Helvetica Neue\', Helvetica, Arial, sans-serif;',
            fontSize: '25px',
          },
          format: '{y}%',
          y: -20,
        }
      }]
    })


    const HighchartsObj = <GaugeContentWrapper>
      <GaugeContainer innerRef={this.graphContainerDiv1}>
        <GaugeHeading>Root Zone Average</GaugeHeading>
        <HighchartsReact
          ref={this.highChartsChart2}
          highcharts={Highcharts}
          options={chartIndividualDepths}
          allowChartUpdate={false}
        />
      </GaugeContainer>
    </GaugeContentWrapper>

    const title = "Gauge" //site ? `${site.name}: ${dataView.name}` : dataView.name

    return <DataViewModalContainer>
      <HelmetTitle title={title} />
      {(state.mobileLandscapeView===false) && <ContainerHeading
        title={title}
        actionIcons={
          <ContainerHeadingActionIcon onClick={this.props.closeDataViewHandler}><CloseCircle /></ContainerHeadingActionIcon>
        }
      />}
      {(state.mobileLandscapeView===false) && includeGraphActions && <GraphActionsBar
        manualInputFormOpenHandler={props.manualInputFormOpenHandler}
      />}
      {HighchartsObj}
    </DataViewModalContainer>
  }

  render = () => this.renderBody(this.props,this.state)

}




// WEBPACK FOOTER //
// ./src/components/dataViews/Gauge.js